import type { Measure } from '../types/theme';

export const withMeasure = (unit: number, measure: Measure) => `${unit}${measure}`;
